import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.string.fixed.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import dayjs from 'dayjs';
import { saveConfig, findConfig } from '@/api/settings';
import Sortable from 'sortablejs';
export default {
  name: 'Table',
  props: {
    selectable: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    showDragButton: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    rowClassName: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    loading: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // 是否可以选择
    hasSelection: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // 是否有分页
    hasPagination: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // 是否有序列项
    hasIndex: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // 这是相应的字段展示
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 这是数据源
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    pagination: {
      type: Object,
      default: function _default() {
        return {
          page: 1,
          pageSize: 10
        };
      }
    },
    slotIndex: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    cacheName: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  components: {
    Sortable: Sortable
  },
  mounted: function mounted() {
    this.init();
  },
  data: function data() {
    return {
      tamptime: new Date().valueOf(),
      sortable: null,
      localColumnsList: [],
      // 本地设置
      remoteColumnsList: [] // 远程设置

    };
  },
  methods: {
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, findRes, removeItem;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;
                that.localColumnsList = that.columns;

                if (!that.showDragButton) {
                  _context.next = 9;
                  break;
                }

                _context.next = 5;
                return findConfig({
                  key: that.cacheName
                });

              case 5:
                findRes = _context.sent;

                if (findRes.reconfig.key) {
                  that.remoteColumnsList = JSON.parse(findRes.reconfig.value);
                  that.localColumnsList.map(function (item) {
                    var findRow = that.remoteColumnsList.find(function (item2) {
                      return item2.prop === item.prop;
                    });

                    if (!findRow) {
                      var findRowByLabel = that.remoteColumnsList.find(function (item2) {
                        return item2.label === item.label;
                      });

                      if (findRowByLabel) {
                        that.remoteColumnsList.splice(that.remoteColumnsList.indexOf(findRowByLabel), 1);
                      }

                      that.remoteColumnsList.push(item);
                    } else {
                      findRow.label = item.label;
                      findRow.width = item.width;
                      findRow.type = item.type;
                      findRow.fixed = item.fixed;
                      findRow.slot = item.slot;
                      findRow.fixedWidth = item.fixedWidth;
                      findRow.dragIgnore = item.dragIgnore;
                      findRow.formatter = item.formatter;
                      findRow.hide = item.hide;
                    }
                  }); // 删除远程作废的列

                  removeItem = [];
                  that.remoteColumnsList.forEach(function (row, index) {
                    var findRow = that.localColumnsList.find(function (item) {
                      return item.prop === row.prop;
                    });

                    if (!findRow) {
                      removeItem.push(row);
                    }
                  });

                  if (removeItem.length > 0) {
                    removeItem.forEach(function (item) {
                      that.remoteColumnsList.splice(that.remoteColumnsList.indexOf(item), 1);
                    });
                  }

                  that.saveTableSet();
                } else {
                  that.remoteColumnsList = that.localColumnsList;
                }

                _context.next = 10;
                break;

              case 9:
                that.remoteColumnsList = that.columns;

              case 10:
                console.log('that.remoteColumnsList', that.remoteColumnsList);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    initDrag: function initDrag() {
      var that = this;
      that.$nextTick(function () {
        var el = document.querySelectorAll('.el-table__fixed-header-wrapper .dragHeaderTable')[0];
        that.sortable = new Sortable(el, {
          onEnd: function onEnd(_ref) {
            var newIndex = _ref.newIndex,
                oldIndex = _ref.oldIndex;
            var currRow = that.remoteColumnsList.splice(oldIndex, 1)[0];
            that.remoteColumnsList.splice(newIndex, 0, currRow);
            that.saveTableSet();
          },
          dragClass: 'dragClass',
          ghostClass: 'ghostClass',
          chosenClass: 'chosenClass',
          filter: '.ignore-elements',
          draggable: '.item'
        });
      });
    },
    rowClick: function rowClick(row, column, event) {
      var that = this;
      that.$emit('row-click', row, column, event);
    },
    rowDblclick: function rowDblclick(row, column, event) {
      var that = this;
      that.$emit('row-dblclick', row, column, event);
    },
    selectionChange: function selectionChange(selection) {
      var that = this;
      that.$emit('selection-change', selection);
    },
    setCurrentRow: function setCurrentRow(row) {
      var that = this;
      that.$refs.listTableRef.setCurrentRow(row);
    },
    indexFormatter: function indexFormatter(index) {
      var that = this;
      return (that.pagination.page - 1) * that.pagination.pageSize + index + 1;
    },
    dataTypeFormatter: function dataTypeFormatter(val, type) {
      if (val !== null && val !== '' && val !== undefined) {
        if (type === 'money') {
          return Number(val).toFixed(2);
        } else if (type === 'date') {
          return dayjs(val).format('YYYY-MM-DD');
        } else if (type === 'time') {
          return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
        } else if (type === 'number') {
          return Number(val);
        } else {
          return val;
        }
      } else {
        return val;
      }
    },
    saveTableSet: function saveTableSet() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2;
                that.tamptime = new Date().valueOf();
                _context2.next = 4;
                return saveConfig({
                  key: that.cacheName,
                  value: JSON.stringify(that.remoteColumnsList)
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    attribName: function attribName(row) {
      if (row.width === 'auto') {
        return 'width';
      } else if (row.fixedWidth && !isNaN(row.width)) {
        return 'width';
      } else {
        return 'min-width';
      }
    },
    selections: function selections() {
      var that = this;
      return that.$refs.listTableRef.selection;
    },
    currentChange: function currentChange(currentRow, oldCurrentRow) {
      var that = this;
      that.$emit('current-change', currentRow, oldCurrentRow);
    },
    pageChange: function pageChange(page) {
      var that = this;
      that.$emit('pageChange', page);
    },
    sizeChange: function sizeChange(pageSize) {
      var that = this;
      that.$emit('sizeChange', pageSize);
    }
  }
};